'use client';

import { PlanPrice, getPlanPrice } from '@services/products';

import { MobilePlanType } from '@app-types/plan';

import { ModalPlanDetails } from '@components/product-details-modal';

import { MarketingsState } from '@hooks/use-marketings';

type ModalPlanDetailsContainerProps = {
    selectedOffer: MobilePlanType;
    onClose: () => void;
    marketingDiscounts: MarketingsState;
    customPrice?: PlanPrice; // Optional custom price for the plan
};

export function ModalPlanDetailsContainer({
    selectedOffer,
    onClose,
    marketingDiscounts,
    customPrice,
}: Readonly<ModalPlanDetailsContainerProps>) {
    return (
        <ModalPlanDetails
            plan={selectedOffer}
            price={customPrice ?? getPlanPrice(selectedOffer, marketingDiscounts, true)}
            isOpen={!!selectedOffer}
            onClose={onClose}
            showBlockedCheckbox
        />
    );
}
